export type StylizedNumberedListFieldName = 'title' | `item.${string}`;

export function createStylizedNumberedListItemFieldName(
  itemId: string
): StylizedNumberedListFieldName {
  return `item.${itemId}`;
}
